import { createPublicEnv } from 'next-public-env';

// Only NEXT_PUBLIC_* and _NEXT_PUBLIC_* environment variables are allowed here.
// See eslint-plugin @terra/eslint-plugin-sacred-rules for enforcement.

export const { getPublicEnv, PublicEnv } = createPublicEnv({
  NEXT_PUBLIC_API_GATEWAY_ADDRESS:
    process.env._NEXT_PUBLIC_API_GATEWAY_ADDRESS ||
    process.env.NEXT_PUBLIC_API_GATEWAY_ADDRESS,
  // the customer terra.security app url
  NEXT_PUBLIC_TERRA_DASHBOARD_URL:
    process.env._NEXT_PUBLIC_TERRA_DASHBOARD_URL ||
    process.env.NEXT_PUBLIC_TERRA_DASHBOARD_URL,
  NEXT_PUBLIC_PORTAL_APP_URL:
    process.env._NEXT_PUBLIC_PORTAL_APP_URL ||
    process.env.NEXT_PUBLIC_PORTAL_APP_URL,
  NEXT_PUBLIC_AUTH_BASE_URL:
    process.env._NEXT_PUBLIC_AUTH_BASE_URL ||
    process.env.NEXT_PUBLIC_AUTH_BASE_URL,
  NEXT_PUBLIC_AUTH_PROVIDER:
    process.env._NEXT_PUBLIC_AUTH_PROVIDER ||
    process.env.NEXT_PUBLIC_AUTH_PROVIDER,
  NEXT_PUBLIC_DESCOPE_PROJECT_ID:
    process.env._NEXT_PUBLIC_DESCOPE_PROJECT_ID ||
    process.env.NEXT_PUBLIC_DESCOPE_PROJECT_ID,
  NEXT_PUBLIC_DESCOPE_BASE_URL:
    process.env._NEXT_PUBLIC_DESCOPE_BASE_URL ||
    process.env.NEXT_PUBLIC_DESCOPE_BASE_URL,
  NEXT_PUBLIC_DESCOPE_SESSION_COOKIE_NAME:
    process.env._NEXT_PUBLIC_DESCOPE_SESSION_COOKIE_NAME ||
    process.env.NEXT_PUBLIC_DESCOPE_SESSION_COOKIE_NAME,
  NEXT_PUBLIC_REFRESH_TOKEN_NAME:
    process.env._NEXT_PUBLIC_REFRESH_TOKEN_NAME ||
    process.env.NEXT_PUBLIC_REFRESH_TOKEN_NAME,
  NEXT_PUBLIC_OIDC_ISSUER_URL:
    process.env._NEXT_PUBLIC_OIDC_ISSUER_URL ||
    process.env.NEXT_PUBLIC_OIDC_ISSUER_URL,
  NEXT_PUBLIC_OIDC_CLIENT_ID:
    process.env._NEXT_PUBLIC_OIDC_CLIENT_ID ||
    process.env.NEXT_PUBLIC_OIDC_CLIENT_ID,
  NEXT_PUBLIC_OIDC_REDIRECT_URI:
    process.env._NEXT_PUBLIC_OIDC_REDIRECT_URI ||
    process.env.NEXT_PUBLIC_OIDC_REDIRECT_URI,
  NEXT_PUBLIC_OIDC_SCOPES:
    process.env._NEXT_PUBLIC_OIDC_SCOPES || process.env.NEXT_PUBLIC_OIDC_SCOPES,
  NEXT_PUBLIC_OIDC_COGNITO_DOMAIN:
    process.env._NEXT_PUBLIC_OIDC_COGNITO_DOMAIN ||
    process.env.NEXT_PUBLIC_OIDC_COGNITO_DOMAIN,
  NEXT_PUBLIC_OIDC_LOGOUT_URI:
    process.env._NEXT_PUBLIC_OIDC_LOGOUT_URI ||
    process.env.NEXT_PUBLIC_OIDC_LOGOUT_URI,
  NEXT_PUBLIC_CORALOGIX_RUM_PUBLIC_KEY:
    process.env._NEXT_PUBLIC_CORALOGIX_RUM_PUBLIC_KEY ||
    process.env.NEXT_PUBLIC_CORALOGIX_RUM_PUBLIC_KEY,
  NEXT_PUBLIC_CORALOGIX_DOMAIN:
    process.env._NEXT_PUBLIC_CORALOGIX_DOMAIN ||
    process.env.NEXT_PUBLIC_CORALOGIX_DOMAIN,
  NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN:
    process.env._NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN ||
    process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN,
  NEXT_PUBLIC_POSTHOG_API_HOST:
    process.env._NEXT_PUBLIC_POSTHOG_API_HOST ||
    process.env.NEXT_PUBLIC_POSTHOG_API_HOST,
  NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA:
    process.env._NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA ||
    process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
  NEXT_PUBLIC_SHOW_REGION_SWITCHER:
    process.env._NEXT_PUBLIC_SHOW_REGION_SWITCHER ||
    process.env.NEXT_PUBLIC_SHOW_REGION_SWITCHER,
  NEXT_PUBLIC_UI_BRANDING_ENABLED:
    process.env._NEXT_PUBLIC_UI_BRANDING_ENABLED ||
    process.env.NEXT_PUBLIC_UI_BRANDING_ENABLED,
  NEXT_PUBLIC_UI_BRANDING_NAME:
    process.env._NEXT_PUBLIC_UI_BRANDING_NAME ||
    process.env.NEXT_PUBLIC_UI_BRANDING_NAME,
  NEXT_PUBLIC_UI_BRANDING_LOGO_BASE64:
    process.env._NEXT_PUBLIC_UI_BRANDING_LOGO_BASE64 ||
    process.env.NEXT_PUBLIC_UI_BRANDING_LOGO_BASE64,
  NEXT_PUBLIC_UI_BRANDING_FAVICON_BASE64:
    process.env._NEXT_PUBLIC_UI_BRANDING_FAVICON_BASE64 ||
    process.env.NEXT_PUBLIC_UI_BRANDING_FAVICON_BASE64,
});
